import {
  Component,
  Input,
  Inject,
  OnInit,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewEncapsulation,
  TemplateRef,
} from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import * as moment from 'moment'; 

import { ShareDocumentsService } from '../../shared-services/share-documents.service';
import {
  CustomValidators,
  errorMessages,
  MyErrorStateMatcher,
} from '../../documents/add-documents/date.match';
import { AuthenticationService } from 'src/app/shared-services/authentication.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { formatDate } from '@angular/common';
import { AlertService } from 'src/app/shared-services/alert.service';
import { AdminService } from 'src/app/shared-services/adminservice.service';
import { IfStmt } from '@angular/compiler';
import { DomSanitizer } from '@angular/platform-browser';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { FileMimeType } from '@taldor-ltd/angular-file-viewer';

@Component({
  selector: 'app-add-documents',
  templateUrl: './add-documents.component.html',
  styleUrls: ['./add-documents.component.scss']
})
export class AddDocumentsComponent implements OnInit {
  newDocumentForm: FormGroup;
  uploadFileForm: FormGroup;
  documentNameFilterCtrl: FormControl = new FormControl();
  stateNameFilterCtrl: FormControl = new FormControl();
  postedValues: any;
  matcher = new MyErrorStateMatcher();
  errors = errorMessages;
  documentNames: any;
  stateNames:any;
  uploadedDocsName:any;
  documentTypes;
  docId: number;
  uploadedDocument;
  uploadedDocInfo:any ={};
  isloading:boolean;
  public file:any ={};
  public uploadText;
  public isFilename:boolean;
  public isDelete:boolean;
  public isDone:boolean;
  public response;
  public dates;
  public isUpdate:boolean;
  public documentsData;
  public isOpenDates:boolean;
  public showBtn:boolean;
  public updateBtn:boolean;
  public isUploaded:boolean;
  public text;
  public isEdit;
  public isExpDateMand:boolean;
  public isLicense:boolean;
  public isCancelBtn:boolean;
  public previousDocumentStoredPathWithSlice;
  public documentNameSelected:boolean;
  public noExpDate:boolean;
  public expDateMandValu:any;
  public duration;
  public fileName ="";
  public isdocDisable:boolean;
  public displayMessage:boolean;
  public isExpDateExist=false;
  public viewFile=false;
  public isAdminAcc:boolean;
  public notification: string = 'YES'; // default checked
  isBarLoading = false;
  progress:number = 0;
  progressInterval: any;
  private cancelUpload$ = new Subject<void>();
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  @ViewChild("notifications") notifications:TemplateRef<any>;
  @ViewChild("isDocExpired") isDocExpired:TemplateRef<any>;
  @ViewChild("isupdateDocExpired") isupdateDocExpired:TemplateRef<any>;
  @ViewChild("isPreview") isPreview:TemplateRef<any>;
  @ViewChild("fileViewer") fileViewer:TemplateRef<any>;
  dialogRef!: MatDialogRef<any>;
  public accuracy="" ;
  isImage: any;
  isPdf: boolean;
  previewUrl: any;
  isUnsupported: boolean;
  filteredDocumentNames: any;
  filteredStateNames:any
   previewdata:any={};
  documentName: any;
  isSafari: boolean;
  constructor(
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private shareDocumentsService: ShareDocumentsService,
    private alertService: AlertService,
    public sanitizer:DomSanitizer,
    private adminService: AdminService,
    private authenticationService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // if(data.uploadFileForm !=null || data.uploadFileForm !=undefined){
    //   this.fileChange(data);
    // }
    this.createDocumentForm();
    this.getDocumentName();
    
   
     // Initially show all
     

     // Filter as user types
     this.documentNameFilterCtrl.valueChanges
       .pipe(debounceTime(300))
       .subscribe(searchText => {
         const search = searchText?.toLowerCase() || '';
         if(this.documentNames !=undefined){
         this.filteredDocumentNames = this.documentNames.filter(doc =>
           doc.documentName.toLowerCase().includes(search)
         );
       }
       });
   this.getStatetName();

    // Filter as user types
    this.stateNameFilterCtrl.valueChanges
    .pipe(debounceTime(300))
    .subscribe(searchText => {
      const search = searchText?.toLowerCase() || '';
      if(this.stateNames !=undefined){
      this.filteredStateNames = this.stateNames.filter(doc =>
        doc.name.toLowerCase().includes(search)
      );
    }
    });
    // this.uploadFileForm = this.formBuilder.group({
    //   uploadDocument: [null, [Validators.required]],

    // })
     this.shareDocumentsService.editData.subscribe((res)=>{ /** subscribe when user click on edit icon in home screen table (action column) */
       this.isUpdate = true;
       this.updateBtn = true;
       this.isEdit = true;
       this.isdocDisable = true;
      //console.log('data', res);
      this.documentsData = res;
      this.isFilename = true;
      //slice(11, -1)
      this.fileName = res.documentStoredPath.slice(11);
      this.previousDocumentStoredPathWithSlice = res.documentStoredPath.slice(11);
      this.newDocumentForm.controls['documentName'].setValue(res.documentName);
      //this.fileChanges(this.file);
      this.newDocumentForm.controls['uploadFileForm'].get('uploadDocument').clearValidators();
      this.newDocumentForm.controls['uploadFileForm'].get('uploadDocument').updateValueAndValidity();
      sessionStorage.setItem("previousDocumentStoredPath", res.documentStoredPath);
      
      
      this.newDocumentForm.controls['description'].setValue(res.documentDescription);
      this.docId = res.docTypeId;
      this.documentName = res.documentName;
      this.documentTypes = res.documentType;

      this.duration = res.duration;
      if(res.docTypeId !=null){
        this.documentNameSelected = true;
        this.isdocDisable = true;
      }else{
        this.documentNameSelected = false;
        this.isdocDisable = false;
      }
     
     // let expiryDate = this.dateformatter(res.expirationDate);
      //let uploadDate = this.dateformatter(res.startDate);

      if(res.expirationDate !=null && res.expirationDate !=""  && res.expirationMandatory != "No" ){
        this.isExpDateExist = true;
        let expDate = formatDate(new Date(res.expirationDate),'yyyy-MM-dd','en')
        this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue(expDate);
        sessionStorage.setItem("previousExpirationDate", expDate);
      }else{
        this.isExpDateExist = false;
        this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue("");
        sessionStorage.setItem("previousExpirationDate", "");
      }
      
      if(res.startDate !=null && res.startDate !=""){
        let startDate = formatDate(new Date(res.startDate),'yyyy-MM-dd','en')
        sessionStorage.setItem("previousStartDate", startDate);
      this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue(startDate);
      }else{
      sessionStorage.setItem("previousStartDate", "");
      this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue("");
      }
      // }else{
      //   sessionStorage.setItem("previousStartDate", formatDate(res.startDate,'mm/dd/yyyy','en'));
      // }
      this.newDocumentForm.controls['documentType'].setValue(res.documentType);
      if (res.expirationMandatory == "Yes"  && !(res.documentName.includes("Nursys") || (res.documentName.includes("State Lic Verification")))) {
        this.isExpDateMand = true;
        this.noExpDate = false;
        this.newDocumentForm.get('dateGroup.expiryDate').setValidators([Validators.required]);
      } else if(res.expirationMandatory == "Auto") {
        this.isExpDateMand = false;
        this.noExpDate = false;
        this.newDocumentForm.get('dateGroup.expiryDate').clearValidators();
      }else{
        this.noExpDate = true;
        this.isExpDateMand = false;
        this.newDocumentForm.get('dateGroup.expiryDate').clearValidators();
      }
      if(res.documentType === "Resume" || res.documentName === "Nursys" || res.documentName === "State Lic Verification"){
        this.isOpenDates =false;
      }else{
        this.isOpenDates =true;
      }
      if(!res.documentType.includes("Resume") && !res.documentName.includes("Nursys") && !res.documentName.includes("State Lic Verification") && res.stateName !=null){
        this.newDocumentForm.controls['dateGroup']
        .get('stateName')
        ?.setValue(res.stateName);
      }else{
        this.newDocumentForm.controls['dateGroup'].get('stateName').setValue(res.stateName);
      }
      if((res.documentType.includes("License") || res.documentType.includes("License/Certificate")) && !(res.documentName.includes("Nursys") || res.documentName.includes("State Lic Verification"))){
        this.isLicense = true;
        this.newDocumentForm.get('dateGroup.stateName').setValidators([Validators.required]);
      }else{
        this.isLicense = false;
        this.newDocumentForm.get('dateGroup.stateName').clearValidators();
      }
      // After setting the validators, you need to update the control's validation state
      this.newDocumentForm.get('dateGroup.expiryDate').updateValueAndValidity();
      this.newDocumentForm.get('dateGroup.stateName').updateValueAndValidity();
  })
  
  }
  dateformatter(params){ /** for date format */
      var dateSplit = params.value.split("T");
      var dateSplit1 = dateSplit[0].split("-");
      var date = dateSplit1[2];
      var month = dateSplit1[1];
      var year = dateSplit1[0];
      var fullDate = date.concat("/", month, "/", year);
      return fullDate;
     // return moment(params.value).format('dd/MM/yyyy'); 
  }
  ngOnInit() {
    if(localStorage.getItem('Authority') === "ADMIN"){
      this.isAdminAcc = true;
    }
    else{
      this.isAdminAcc = false;
    }
    sessionStorage.setItem('isNextTab', 'yes');
    document.body.style.backgroundImage = "none";
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
   // this.uploadText ='Upload';
    this.shareDocumentsService.currentMessage.subscribe(
      (message) => (this.postedValues = message)
    );
    
  }

  createDocumentForm() { /** upload/edit document form */
    this.newDocumentForm = this.formBuilder.group({
      documentName: [null, [Validators.required]],
      documentType:[null, [Validators.required]],
      description:[null, [ Validators.maxLength(100)]],
      uploadFileForm : this.formBuilder.group({
        uploadDocument: [null, [Validators.required]], 
      }),
      dateGroup: this.formBuilder.group(
        {
          expiryDate: [null, []],
          uploadDate: [null, []],
          stateName:[null, []],
        },
        {
          validator: CustomValidators.checkDates,
        }
      ),
    });
  }

  getDocumentName() { /** get document names */
    if (!this.documentNames || this.documentNames.length === 0) {
      this.authenticationService
        .getDocumentNames()
        .subscribe((documentsObj) => {
          if (documentsObj) {
            this.documentNames = documentsObj.body;
            this.filteredDocumentNames = this.documentNames;
            // this.documentNames.sort(function(a, b) {
            //   var nameA = a.documentName.toUpperCase(); // ignore upper and lowercase
            //   var nameB = b.documentName.toUpperCase(); // ignore upper and lowercase
            //   // if(nameA == "OTHER"){
            //   //   nameA = "Zzzz"+nameA;
            //   // }
            //   // if(nameB == "OTHER"){
            //   //   nameB = "Zzzz"+nameB;
            //   // }
            //   if (nameA < nameB ) {
            //     return -1;
            //   }
            //   if (nameA > nameB) {
            //     return 1;
            //   }
            
            //   // names must be equal
            //   return 0;
            // });
      //       if(this.isUpdate){
      //         const toSelectDocName = this.documentNames.find(c => c.documentName == this.documentsData.documentName);
      // this.newDocumentForm.controls['documentName'].setValue(toSelectDocName.documentName);
      //       }
          }
        });
    }
  }
  
 
  populatedocType(event) { /** for document type */
    let i = event.value;
    if(event.value !=null){
     this.documentNameFilterCtrl.setValue('');
      this.documentNameSelected = true;
    }else{
      this.documentNameSelected = false;
    }
    for(let a=0; a<this.documentNames.length; a++){
      if(this.documentNames[a].documentName === i){
        this.documentTypes = this.documentNames[a].documentType;
        this.expDateMandValu = this.documentNames[a].expirationMandatory;
        this.duration = this.documentNames[a].duration;

        this.newDocumentForm.controls['documentType'].setValue( this.documentNames[a].documentType);
        this.documentName = this.documentNames[a].documentName;
if((this.documentTypes.includes("License") || this.documentTypes.includes("License/Certificate")) && !(this.documentName.includes("Nursys") || this.documentName.includes("State Lic Verification"))){
  this.isLicense = true;
  this.newDocumentForm.get('dateGroup.stateName').setValidators([Validators.required]);
}else{
  this.isLicense = false;
  this.newDocumentForm.get('dateGroup.stateName').clearValidators();
}
        this.docId = this.documentNames[a].id;
        
      }
    }
    if(this.isDone || this.fileName !=""){
      this.isOpenDates = false;
      this.isDone = false;  
      this.isloading = false;
      this.isBarLoading = false;
       this.isEdit = false;
       this.fileName ="";
       this.isPdf = false;
       this.isImage = false;
      this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue("");
      this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue("");
      this.newDocumentForm.controls['uploadFileForm'].get('uploadDocument').setValue("");
      this.isUploaded = this.uploadFileForm.valid;
      console.log('Cancelling upload due to name change');
    this.cancelUpload$.next();
     // this.deleteDocument("changeDocName");
//       let startDate = new Date(this.newDocumentForm.controls['dateGroup'].get('uploadDate').value);
//       // Add 1 year
// startDate.setFullYear(startDate.getFullYear() + parseInt(this.duration.split(" years")[0], 10));

// // Format the new date to 'yyyy-MM-dd'
// let expDate = formatDate(startDate, 'yyyy-MM-dd', 'en');

// // Set the new expiry date in the form
// this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue(expDate);

    }
    // if(this.documentTypes =="Certification" || this.documentTypes =="License/Certificate"){
    //   this.isExpDateMand = true;
    //   this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValidators([Validators.required])

    // }else{
    //   this.isExpDateMand = false;
    //   this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValidators(null)
    // }
    if (this.expDateMandValu == "Yes" && !(this.documentName.includes("Nursys") || this.documentName.includes("State Lic Verification"))) {
      this.isExpDateMand = true;
      this.noExpDate = false;
      this.newDocumentForm.get('dateGroup.expiryDate').setValidators([Validators.required]);
    } else if(this.expDateMandValu == "Auto") {
      this.isExpDateMand = false;
      this.noExpDate = false;
      this.newDocumentForm.get('dateGroup.expiryDate').clearValidators();
    }else{
      this.noExpDate = true;
      this.isExpDateMand = false;
      this.newDocumentForm.get('dateGroup.expiryDate').clearValidators();
    }
  
    if(this.documentTypes === "Resume"){
      this.isOpenDates = false;
    }
    // After setting the validators, you need to update the control's validation state
    this.newDocumentForm.get('dateGroup.expiryDate').updateValueAndValidity();
    this.newDocumentForm.get('dateGroup.stateName').updateValueAndValidity();
  }
  uploadFile(){ /** upload selected file */
    this.isloading = true;
    this.isBarLoading = true;
    this.progress = 0;
    this.startFakeProgress();
    this.cancelUpload$.next();
    this.cancelUpload$ = new Subject(); 
    if(!this.isUpdate){ /** for upload file not for edit */
    sessionStorage.removeItem("previousDocumentStoredPath");
    sessionStorage.removeItem("previousExpirationDate");
    sessionStorage.removeItem("previousStartDate");
     // Cancel the previous one (if any)
    // Recreate for the next time
    this.shareDocumentsService
    .uploadDocuments(this.uploadedDocument)
    .pipe(takeUntil(this.cancelUpload$))
    .subscribe({
      next:(result) => {
    //  this.uploadedDocsName.push(result.documentStoredPath);
    this.completeProgress();
      sessionStorage.setItem('uploadedDocs', this.uploadedDocsName);
      this.isDone = true;
      //  console.log('User successfully created!', result);
        this.response = result;        
        console.log(this.documentTypes.includes("Resume"));
        if(this.documentTypes.includes("Resume") || this.documentName.includes("Nursys") || this.documentName.includes("State Lic Verification")){
          this.isOpenDates =false;
          
        }else if(this.expDateMandValu == "No" && !this.documentTypes.includes("Resume") && !this.documentName.includes("Nursys") && !this.documentName.includes("State Lic Verification")){
          this.isOpenDates =true;
          this.noExpDate = true;
          if(this.response.startDate !=null){
            let startDate = formatDate(new Date(this.response.startDate),'yyyy-MM-dd','en')
            this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue(startDate);
            //this.hasStartDate = true;
          }else{
            
    this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue('');
    //this.hasStartDate = false;
          }
        }
        else{
          this.isOpenDates =true;
          if(this.response.expirationDate !=null){
            this.isExpDateExist = true;
            let expDate = formatDate(new Date(this.response.expirationDate),'yyyy-MM-dd','en')
          
            this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue(expDate);
          }else{
            this.isExpDateExist = false;
          this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue('');
          }
          if(this.response.startDate !=null){
            let startDate = formatDate(new Date(this.response.startDate),'yyyy-MM-dd','en')
            this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue(startDate);
         //   this.hasStartDate = true;
          }else{
    this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue('');
   // this.hasStartDate = false;
          }
        }
        if(this.response.expirationDate !=null || this.response.startDate !=null){
          this.displayMessage = true;
        }else{
          this.displayMessage = false;
        }
        this.showBtn = true;
        this.uploadedDocInfo.documentStoredPath = this.response.documentStoredPath;
        if(!this.documentTypes.includes("Resume") && !this.documentName.includes("Nursys") && !this.documentName.includes("State Lic Verification") && this.response.stateName !=null){
          this.newDocumentForm.controls['dateGroup']
          .get('stateName')
          ?.setValue(this.response.stateName);
        }
        else{
          this.newDocumentForm.controls['dateGroup'].get('stateName').setValue(this.response.stateName);
        }
    setTimeout(() => {
      this.progress = 0;
    }, 1500);
    this.isDelete = true;
    this.isloading = false;
    this.isBarLoading = false;
          // this.uploadedDocInfo.documentStoredPath = event.body.documentStoredPath;
      //this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue(event.expirationDate);
     // this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue(event.uploadedDate);
      return result;
    },
    error: (error)=>{
this.isloading = false;
this.isBarLoading = false;
console.log("error",error);
     // alert("something went wrong, please try again");
    }
    ,
      complete: () => {
        console.log('Upload complete');
      }
    });
  }
  else{ /** edit uploaded file */
  if(localStorage.getItem('Authority') === "ADMIN"){
  this.adminService.selectFileUploadByAdmin(this.uploadedDocument)
  .pipe(takeUntil(this.cancelUpload$)).subscribe((result) => {
      
    this.isDone = true;
    this.edituploadFile(result);
  })
  }else{
    this.shareDocumentsService.updateUploadDocuments(this.uploadedDocument)
    .pipe(takeUntil(this.cancelUpload$))
    .subscribe((result) => {
      
      this.isDone = true;
      this.edituploadFile(result);
    })
  }
  
  }
  
  }

  clearDate(value) {
    if(value =="uploadDate"){
      this.newDocumentForm.get('dateGroup.uploadDate')?.setValue('');
      if(!this.isExpDateExist && (this.newDocumentForm.controls['dateGroup'].get('expiryDate').value !="") && (this.newDocumentForm.controls['dateGroup'].get('expiryDate').value != null)){
        this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue("");
        this.displayMessage = false;
        
      }
    }else if(value== "expiryDate"){
      this.newDocumentForm.get('dateGroup.expiryDate')?.setValue('');
      this.isExpDateExist = false;
    }
  }


  startFakeProgress() {
    // Increase progress smoothly until 90%
    this.progressInterval = setInterval(() => {
      if (this.progress < 90) {
        this.progress += 3; // +3% every second
      }
    }, 1000);
  }

  completeProgress() {
    clearInterval(this.progressInterval);
    this.progress = 100;
    setTimeout(() => {
      this.isBarLoading = false;
    }, 500); // small delay to show full bar
  }


  previewFile(){
    if(this.isEdit){
      this.viewFile = true;
     this.dialogRef = this.dialog.open(this.fileViewer);
    }else{
    this.dialogRef = this.dialog.open(this.isPreview, {
      width: '600px',
      disableClose: true  // Optional: prevent clicking outside to close
    });
  }
   // this.dialog.open(this.isPreview);
   
  }
  edituploadFile(respone){
    if(respone !=null || respone !=undefined){
      this.response = respone.responseData;
      if(this.response.expirationDate !=null || this.response.startDate !=null){
        this.displayMessage = true;
      }else{
        this.displayMessage = false;
      }
      if(this.documentTypes.includes("Resume") || this.documentName.includes("Nursys") || this.documentName.includes("State Lic Verification")){
        this.isOpenDates =false;
        
      }
      else if(this.expDateMandValu == "No" && !this.documentTypes.includes("Resume") && !this.documentName.includes("Nursys") && !this.documentName.includes("State Lic Verification")){
        this.isOpenDates =true;
        this.noExpDate = true;
        if(respone.startDate !=null){
          let startDate = formatDate(new Date(respone.startDate),'yyyy-MM-dd','en')
          this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue(startDate);
        }else{
  this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue(respone.startDate);
        }
      }
      else{
        this.isOpenDates =true;
        if(respone.responseData.expirationDate !=null){
          let expDate = formatDate(new Date(respone.responseData.expirationDate),'yyyy-MM-dd','en')
        this.isExpDateExist=true;
          this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue(expDate);
        }else{
          this.isExpDateExist = false;
        this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue(respone.responseData.expirationDate);
        }
        if(respone.responseData.startDate !=null){
          let startDate = formatDate(new Date(respone.responseData.startDate),'yyyy-MM-dd','en')
          this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue(startDate);
        }else{
  this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue(respone.responseData.startDate);
        }
      }
      if(!this.documentTypes.includes("Resume") && !this.documentName.includes("Nursys") && !this.documentName.includes("State Lic Verification") && respone.responseData.stateName !=null){
        this.newDocumentForm.controls['dateGroup']
        .get('stateName')
        ?.setValue(respone.responseData.stateName);
      }
      else{
        this.newDocumentForm.controls['dateGroup'].get('stateName').setValue(respone.responseData.stateName);
      }
      this.updateBtn = true;
      sessionStorage.setItem("newDocumentStoredPath",  respone.responseData.documentStoredPath);
     // this.uploadedDocInfo.documentStoredPath = result.responseData.documentStoredPath;
      
  setTimeout(() => {
    this.progress = 0;
  }, 1500);
  this.isDelete = true;
  this.isloading = false;
  this.isBarLoading = false;
        // this.uploadedDocInfo.documentStoredPath = event.body.documentStoredPath;
    //this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue(event.expirationDate);
   // this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue(event.uploadedDate);
    return respone;
}
  }
  deleteDocument(value){ /** delete selected file if replace document */
   // this.file.name = '';
   let inputObj:any={} ;
   if(this.response.documentStoredPath !=null && (sessionStorage.getItem("previousDocumentStoredPath") == null || sessionStorage.getItem("previousDocumentStoredPath") == undefined)){
    inputObj.documentStoredPath = this.response.documentStoredPath;
   inputObj.expirationDate = this.response.expirationDate;
   inputObj.uploadedDate = this.response.uploadedDate;
   }else if(sessionStorage.getItem("previousDocumentStoredPath") != null && sessionStorage.getItem("previousDocumentStoredPath") != undefined && value == "deletePreviousDocument"){
    inputObj.documentStoredPath = sessionStorage.getItem("previousDocumentStoredPath");
    inputObj.expirationDate = sessionStorage.getItem("previousExpirationDate");
    inputObj.startDate = sessionStorage.getItem("previousStartDate");
   }else if(sessionStorage.getItem("previousDocumentStoredPath") != null && sessionStorage.getItem("previousDocumentStoredPath") != undefined && this.response.documentStoredPath !=null && value == "removeFile"){
    inputObj.documentStoredPath = this.response.documentStoredPath;
    inputObj.expirationDate = this.response.expirationDate;
    inputObj.uploadedDate = this.response.uploadedDate;
   // inputObj.oldDocumentStoredPath = sessionStorage.getItem("previousDocumentStoredPath")
    inputObj.caregiverDocId = this.documentsData.caregiverDocId;
    inputObj.nurseId = this.documentsData.nurseId
   }
   else{
    inputObj.documentStoredPath = this.response.documentStoredPath;
    inputObj.expirationDate = this.response.expirationDate;
    inputObj.uploadedDate = this.response.uploadedDate;
    inputObj.oldDocumentStoredPath = sessionStorage.getItem("previousDocumentStoredPath")
    inputObj.caregiverDocId = this.documentsData.caregiverDocId;
    inputObj.nurseId = this.documentsData.nurseId
   }
   this.shareDocumentsService.deleteUploadedDocuments(inputObj).subscribe((res)=>{
    // console.log(res);
    // this.isFilename = false;
     //this.uploadFileForm.get('uploadDocument').setValue('');
    // this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue('');
    // this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue('');
      this.isDone = false;
      this.isDelete = false;
     return res;
   })


  }
  submitNewDocument(values) { /** submit document details with selected file path */
    this.postedValues = values;
    this.uploadedDocInfo.notifyMe = this.notification;
   // if(this.response !=undefined && this.response.accuray!=null && this.response.accuracy.includes("NO")){
      // if(this.response.expirationDate !=null && (this.response.expirationDate == values.dateGroup.expiryDate)){
      //  return alert("Please verify the dates before adding document");
      // }
   // }
    let today = new Date();
    let expiryDate ;
    if(values.dateGroup.expiryDate !=null && values.dateGroup.expiryDate !="") {
      expiryDate = new Date(values.dateGroup.expiryDate);
    }
    // this.postedValues = this.newDocumentForm.get('documentName').value;
    this.shareDocumentsService.changeMessage(values);
    // Clear time parts to compare only the date
today.setHours(0, 0, 0, 0);
expiryDate?.setHours(0, 0, 0, 0);
if(!this.isUpdate){ /** submit document details  */
  if (expiryDate !=undefined && expiryDate < today ){
    this.dialog.open(this.isDocExpired);
  }
  else{
  this.uploadedDocInfo.expirationDate = values.dateGroup.expiryDate;
    this.uploadedDocInfo.startDate = values.dateGroup.uploadDate;
    this.uploadedDocInfo.stateName = this.newDocumentForm.controls['dateGroup'].get('stateName').value;
   // this.uploadedDocInfo.documentDescription = this.newDocumentForm.get('description').value;
    if(this.newDocumentForm.get('description').value == null || this.newDocumentForm.get('description').value == ""){
      this.uploadedDocInfo.documentDescription ="";
    }else{
    this.uploadedDocInfo.documentDescription = this.newDocumentForm.get('description').value;
    }
  this.uploadedDocInfo.docTypeId  = this.docId;
  if(localStorage.getItem('Authority') === "ADMIN"){
   if(this.data.userId !=undefined){
    this.uploadedDocInfo.nurseId = this.data.userId;
   }
   else{
    this.uploadedDocInfo.nurseId = this.data;
   }
   
    this.adminService.uploadDocumentInfoByAdmin(this.uploadedDocInfo).subscribe((res)=>{
      window.scrollTo( 0, 0 );
      document.getElementsByTagName('html')[0].scrollTop=0;
      if(res == "File Upload Sucessful"){
        this.shareDocumentsService.raiseEvent();
        this.alertService.success('Document Uploaded Successfully', this.options);
      }
     else{
      this.alertService.error('Sorry, Document upload failed', this.options);
     }
      return res;
  
    })
  }else{
  this.shareDocumentsService.uploadDocumentInfo(this.uploadedDocInfo).subscribe((res)=>{
    window.scrollTo( 0, 0 );
    document.getElementsByTagName('html')[0].scrollTop=0;
    if(res == "File Upload Sucessful"){
      this.shareDocumentsService.raiseEvent();
      this.alertService.success('Document Uploaded Successfully', this.options);
    }
   else{
    this.alertService.error('Sorry, Document upload failed', this.options);
   }
    return res;

  })}
}
}
else{ /** submit document details for edit */
if (expiryDate !="" && expiryDate < today){
  this.dialog.open(this.isupdateDocExpired);
}
  else{
  this.uploadedDocInfo.caregiverDocId  = this.documentsData.caregiverDocId;
  this.uploadedDocInfo.docTypeId  = this.docId;
  this.uploadedDocInfo.expirationDate = values.dateGroup.expiryDate;
    this.uploadedDocInfo.startDate = values.dateGroup.uploadDate;
    if(this.newDocumentForm.get('description').value == null || this.newDocumentForm.get('description').value == ""){
      this.uploadedDocInfo.documentDescription ="";
    }else{
    this.uploadedDocInfo.documentDescription = this.newDocumentForm.get('description').value;
    }
    this.uploadedDocInfo.stateName = this.newDocumentForm.controls['dateGroup'].get('stateName').value;
    if(sessionStorage.getItem("newDocumentStoredPath") == null || sessionStorage.getItem("newDocumentStoredPath") == undefined){
      this.uploadedDocInfo.documentStoredPath = this.documentsData.documentStoredPath;
    }else{
      this.uploadedDocInfo.documentStoredPath = sessionStorage.getItem("newDocumentStoredPath");
    }
    this.uploadedDocInfo.oldDocumentStoredPath = sessionStorage.getItem("previousDocumentStoredPath");
    if(localStorage.getItem('Authority') === "ADMIN"){
      if(this.data.userId !=undefined){
       this.uploadedDocInfo.nurseId = this.data.userId;
      }
      else{
       this.uploadedDocInfo.nurseId = this.data;
      }
      this.adminService.updateDocInfoByAdmin(this.uploadedDocInfo).subscribe((res:any)=>{
        if(sessionStorage.getItem("previousDocumentStoredPath") != this.uploadedDocInfo.documentStoredPath){
        this.deleteDocument("deletePreviousDocument");
       }
        window.scrollTo( 0, 0 );
        document.getElementsByTagName('html')[0].scrollTop=0;
        if(res.responseMessage == "Data Updated Successfully"){
          this.shareDocumentsService.raiseEvent();
          this.alertService.success('Document updated Successfully', this.options);
        }
       else{
        this.alertService.error('Sorry, Document update failed', this.options);
       }
         // console.log(res);
          //this.shareDocumentsService.raiseEvent();
          sessionStorage.removeItem("newDocumentStoredPath");
          return res;
        })
    }   else{
 this.shareDocumentsService.updateUploadDocumentInfo(this.uploadedDocInfo).subscribe((res)=>{
  if(sessionStorage.getItem("previousDocumentStoredPath") != this.uploadedDocInfo.documentStoredPath){
  this.deleteDocument("deletePreviousDocument");
 }
  window.scrollTo( 0, 0 );
  document.getElementsByTagName('html')[0].scrollTop=0;
  if(res == "Data Updated Successfully"){
    this.shareDocumentsService.raiseEvent();
    this.alertService.success('Document updated Successfully', this.options);
  }
 else{
  this.alertService.error('Sorry, Document update failed', this.options);
 }
   // console.log(res);
    //this.shareDocumentsService.raiseEvent();
    sessionStorage.removeItem("newDocumentStoredPath");
    return res;
  })
}
}
}
     
  }
  submitExpiredDocument(values){
    this.dialog.closeAll();
    this.uploadedDocInfo.expirationDate = values.dateGroup.expiryDate;
    this.uploadedDocInfo.startDate = values.dateGroup.uploadDate;
   /// this.uploadedDocInfo.documentDescription = this.newDocumentForm.get('description').value;
   if(this.newDocumentForm.get('description').value == null || this.newDocumentForm.get('description').value == ""){
    this.uploadedDocInfo.documentDescription ="";
  }else{
  this.uploadedDocInfo.documentDescription = this.newDocumentForm.get('description').value;
  }
  this.uploadedDocInfo.stateName = this.newDocumentForm.controls['dateGroup'].get('stateName').value;
  this.uploadedDocInfo.docTypeId  = this.docId;
  if(localStorage.getItem('Authority') === "ADMIN"){
    if(this.data.userId !=undefined){
      this.uploadedDocInfo.nurseId = this.data.userId;
     }
     else{
      this.uploadedDocInfo.nurseId = this.data;
     }
    this.adminService.uploadDocumentInfoByAdmin(this.uploadedDocInfo).subscribe((res)=>{
      window.scrollTo( 0, 0 );
      document.getElementsByTagName('html')[0].scrollTop=0;
      if(res == "File Upload Sucessful"){
        this.shareDocumentsService.raiseEvent();
        this.alertService.success('Document Uploaded Successfully', this.options);
      }
     else{
      this.alertService.error('Sorry, Document upload failed', this.options);
     }
      return res;
  
    })
  }else{
  this.shareDocumentsService.uploadDocumentInfo(this.uploadedDocInfo).subscribe((res)=>{
    window.scrollTo( 0, 0 );
    document.getElementsByTagName('html')[0].scrollTop=0;
    if(res == "File Upload Sucessful"){
      this.shareDocumentsService.raiseEvent();
      this.alertService.success('Document Uploaded Successfully', this.options);
    }
   else{
    this.alertService.error('Sorry, Document upload failed', this.options);
   }
    return res;

  })}
  }
  updateExpiredDocument(values){
    this.dialog.closeAll();
    this.uploadedDocInfo.caregiverDocId  = this.documentsData.caregiverDocId;
    this.uploadedDocInfo.docTypeId  = this.docId;
    this.uploadedDocInfo.expirationDate = values.dateGroup.expiryDate;
      this.uploadedDocInfo.startDate = values.dateGroup.uploadDate;
     // this.uploadedDocInfo.documentDescription = this.newDocumentForm.get('description').value;
     if(this.newDocumentForm.get('description').value == null || this.newDocumentForm.get('description').value == ""){
      this.uploadedDocInfo.documentDescription ="";
    }else{
    this.uploadedDocInfo.documentDescription = this.newDocumentForm.get('description').value;
    }
    this.uploadedDocInfo.stateName = this.newDocumentForm.controls['dateGroup'].get('stateName').value;
    if(sessionStorage.getItem("newDocumentStoredPath") == null || sessionStorage.getItem("newDocumentStoredPath") == undefined){
      this.uploadedDocInfo.documentStoredPath = this.documentsData.documentStoredPath;
    }else{
      this.uploadedDocInfo.documentStoredPath = sessionStorage.getItem("newDocumentStoredPath");
    }
    //this.uploadedDocInfo.documentStoredPath = sessionStorage.getItem("newDocumentStoredPath");
    this.uploadedDocInfo.oldDocumentStoredPath = sessionStorage.getItem("previousDocumentStoredPath");
    if(localStorage.getItem('Authority') === "ADMIN"){
      if(this.data.userId !=undefined){
       this.uploadedDocInfo.nurseId = this.data.userId;
      }
      else{
       this.uploadedDocInfo.nurseId = this.data;
      }
      this.adminService.updateDocInfoByAdmin(this.uploadedDocInfo).subscribe((res:any)=>{
        if(sessionStorage.getItem("previousDocumentStoredPath") != this.documentsData.documentStoredPath){
          this.deleteDocument("deletePreviousDocument");
         }
        window.scrollTo( 0, 0 );
        document.getElementsByTagName('html')[0].scrollTop=0;
        if(res.responseMessage == "Data Updated Successfully"){
          this.shareDocumentsService.raiseEvent();
          this.alertService.success('Document updated Successfully', this.options);
        }
       else{
        this.alertService.error('Sorry, Document update failed', this.options);
       }
         // console.log(res);
          //this.shareDocumentsService.raiseEvent();
          sessionStorage.removeItem("newDocumentStoredPath");
          return res;
        })
    }else{
   this.shareDocumentsService.updateUploadDocumentInfo(this.uploadedDocInfo).subscribe((res)=>{
    if(sessionStorage.getItem("previousDocumentStoredPath") != this.documentsData.documentStoredPath){
      this.deleteDocument("deletePreviousDocument");
     }
    window.scrollTo( 0, 0 );
    document.getElementsByTagName('html')[0].scrollTop=0;
    if(res == "Data Updated Successfully"){
      this.shareDocumentsService.raiseEvent();
      this.alertService.success('Document updated Successfully', this.options);
    }
   else{
    this.alertService.error('Sorry, Document update failed', this.options);
   }
     // console.log(res);
      //this.shareDocumentsService.raiseEvent();
      sessionStorage.removeItem("newDocumentStoredPath");
      return res;
    })
  }
  
  }
  closeAll(){
    this.removeFile();
    this.dialog.closeAll();
  }
  closePre(){
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
  
 

  fileChange(event, formValues) { /**when select file */  
  const fileInput = event.target as HTMLInputElement;
  // Reset input value to allow selecting the same file
 // fileInput.value = '';
 console.log('Cancelling upload due to name change');
 this.cancelUpload$.next();
   if(this.response !=null){
    // this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue('');
    //  this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue('');
     if(!this.isEdit && (sessionStorage.getItem('selectedDoc') =="" && fileInput.value != "")){
    this.deleteDocument("FileChange");
     }
   }
       this.isEdit = false;
     
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.isDone = false;
      this.isloading = false;
      this.isBarLoading = false;
      this.file = fileList[0];
      if(formValues.controls.uploadFileForm !=undefined){
        sessionStorage.setItem('selectedDoc', formValues.controls['uploadFileForm'].get('uploadDocument').value);
        this.uploadFileForm = formValues.controls.uploadFileForm;
        this.isUploaded = this.uploadFileForm.valid;
        //this.uploadFileForm.controls[''].setValue(this.file.name);
        //this.uploadFileForm.get('uploadDocument').setValue('');
       // this.uploadFileForm.controls['uploadDocument'].setValue("");
      }else{
        this.isUploaded = this.uploadFileForm.valid;
      }
      this.isFilename = true;
      this.fileName = this.file.name;
      if(this.file.name.indexOf('.pdf') !==-1 || this.file.name.indexOf('.png') !== -1 || this.file.name.indexOf('.jpg') !== -1 || this.file.name.indexOf('.jpeg') !== -1) {
        if(this.file.size > 2e+7){
         // this.dialog.open(this.notifications);
          alert('Provided Image size is more than 20Mb so please make sure it should be equal or less than 20Mb')
        }
        else{
          const fileType = this.file.type;
          if (fileType.startsWith('image/')) {
            this.isImage = true;
            const reader = new FileReader();
            reader.onload = () => {
              this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(reader.result as string);
            };
            reader.readAsDataURL(this.file);
          } else if (fileType === 'application/pdf' || fileType.startsWith('video/')) {
            const objectUrl = URL.createObjectURL(this.file);
            this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      
            this.isPdf = fileType === 'application/pdf';
            //this.isVideo = fileType.startsWith('video/');
          } else {
            this.isUnsupported = true;
            const objectUrl = URL.createObjectURL(this.file);
            this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
          }
        let formData: FormData = new FormData();
        formData.append('uploadFile', this.file, this.file.name);
        formData.append('id',this.docId.toString() );
        if(localStorage.getItem('Authority') === "ADMIN"){
        if(this.data.userId !=undefined){
          formData.append('nurseId',this.data.userId);
         }
         else{
          formData.append('nurseId',this.data);
         }
        }
        if(this.isUpdate){
          formData.append('docId', this.documentsData.caregiverDocId);
        }
        // this.uploadedDocument = this.file;
        this.uploadedDocument = formData;
        this.isOpenDates = false;
        this.showBtn = false;
        this.updateBtn = false;
        this.isCancelBtn = true;
        }
      }
      else{
       // this.dialog.open(this.notifications);
        alert("File type should be '.pdf', '.png', '.jpg', 'jpeg'");
       // this.uploadFileForm.get('uploadDocument').setValue('');
        this.newDocumentForm.controls['uploadFileForm'].get('uploadDocument').setValue('');
        this.isFilename = false;
      }
     
    }
    if(sessionStorage.getItem('selectedDoc') !="" && fileInput.value == ""){
      this.newDocumentForm.controls['uploadFileForm'].get('uploadDocument').clearValidators();
    this.newDocumentForm.controls['uploadFileForm'].get('uploadDocument').updateValueAndValidity();
     }
    
  }
  getPreviousData(){
    this.isBarLoading = false;
    if(!this.isUpdate){
      this.removeFile();
      this.dialog.closeAll();
    }else{
      console.log('Cancelling upload due to name change');
    this.cancelUpload$.next();
      this.isPdf = false;
      this.isImage = false;
      this.displayMessage = false;
    if(this.documentTypes.includes("Resume") || this.documentName.includes("Nursys") || this.documentName.includes("State Lic Verification")){
      this.isOpenDates =false;
    }else{
      this.isOpenDates =true;
    }
       // this.isCancelBtn = false;
        this.isEdit = true;
        this.updateBtn = true;
        this.isDone = false
       // if(this.previousDocumentStoredPathWithSlice !=undefined){
          this.fileName = this.previousDocumentStoredPathWithSlice;
          
          if(sessionStorage.getItem("previousExpirationDate") !=null || sessionStorage.getItem("previousExpirationDate") !=undefined){
            this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue(sessionStorage.getItem("previousExpirationDate"));
          }
          if(sessionStorage.getItem("previousStartDate") !=null || sessionStorage.getItem("previousStartDate") !=undefined){
            this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue(sessionStorage.getItem("previousStartDate"));
          }
          sessionStorage.removeItem("newDocumentStoredPath");
      }
      this.isCancelBtn = false;
        
  }
  removeFile(){
    if(this.response !=null){
      this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue('');
       this.newDocumentForm.controls['dateGroup'].get('uploadDate').setValue('');
     //  sessionStorage.removeItem("previousDocumentStoredPath");
      this.deleteDocument("removeFile");
     }
  }
  close(){
    this.dialog.closeAll();
  }
  
  selectStartDate(formvalues){   
    console.log(formvalues);
    
    if(formvalues.controls['dateGroup'].get('uploadDate').value !="" && formvalues.controls['dateGroup'].get('uploadDate').value != null && this.duration !=null){
      if((!this.isExpDateExist) || (formvalues.controls['dateGroup'].get('expiryDate').value =="") || (formvalues.controls['dateGroup'].get('expiryDate').value == null)){ 
      let date = new Date(formvalues.controls['dateGroup'].get('uploadDate').value);
       if(this.documentName.includes("Influenza")){ //QA
      //if(this.docId == 20){ // prod
        

    // Get current year Sept 1st
    let nextSeptFirst = new Date(date.getFullYear(), 8, 1); // Month is 0-based: 8 = September

    // If start date is on or after Sept 1st, move to next year's Sept 1st
    if (date >= nextSeptFirst) {
      nextSeptFirst = new Date(date.getFullYear() + 1, 8, 1);
    }
    date = nextSeptFirst;
      }else if(this.duration.includes("Annual")){
        date.setFullYear(date.getFullYear() + 1); // Add 1 year
        date.setDate(date.getDate() - 1);
      }else{
      date.setFullYear(date.getFullYear() + Number(this.duration.split(" ")[0])); 
      date.setDate(date.getDate() - 1);
      }
    // Subtract 1 day
      let formattedDate = formatDate(date, 'yyyy-MM-dd', 'en');
      this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue(formattedDate);
      this.displayMessage = true;
    }
  }else if(!this.isExpDateExist && (formvalues.controls['dateGroup'].get('expiryDate').value !="") && (formvalues.controls['dateGroup'].get('expiryDate').value != null)){
    this.newDocumentForm.controls['dateGroup'].get('expiryDate').setValue("");
    this.displayMessage = false;
    
  }
}
selectExpDate(event){
  const inputElement = event.target as HTMLInputElement;
  const selectedDate = inputElement.value;
  if(selectedDate == ""){
    this.isExpDateExist = false;
  }
  

}


notifyButton(event: Event, value: string): void {
  const isChecked = (event.target as HTMLInputElement).checked;

  if (isChecked) {
    this.notification = value;
  } else {
    if(value == 'YES'){
      this.notification = 'NO';
    }else{
    this.notification = 'YES';
  }
  }
}


getStatetName() { /** get document names */
if (!this.stateNames || this.stateNames.length === 0) {
  this.shareDocumentsService
    .getStateNames()
    .subscribe((stateObj) => {
      if (stateObj) {
        this.stateNames = stateObj.body.stateNames;
        this.filteredStateNames = this.stateNames;
      
      }
    });
}
}

}
